export const AnalyticsEvents = {
  catalystEvents: {
    /**
     * - action_type: string,
     * - alter_name: string,
     */
    CATALYST_CLICK_ALERT_ACTION: "catalyst_click_alert_action",
    /**
     * - expanded: boolean,
     * - collapse_key: string,
     * - name: string,
     */
    CATALYST_CLICK_COLLAPSE: "catalyst_click_collapse"
  },
  commonEvents: {
    /**
     * - name: string,
     * - error_type: 'empty_text' | 'function_not_supported' | 'error',
     */
    COPY_TO_CLIPBOARD: "copy_to_clipboard"
  },
  workflowDetailEvents: {
    HEADER_CLICK_STATUS: "wfd_header_click_status",
    HEADER_CLICK_OPEN_WF_COMMENTS: "wfd_header_click_openWFComments",
    HEADER_BREADCRUMB_CLICK_OPEN_WORKFLOW:
      "wfd_header_breadcrumb_click_openWorkflow",
    HEADER_CLICK_UNFOLLOW_WORKFLOW: "wfd_header_click_unfollowWorkflow",
    HEADER_CLICK_FOLLOW_WORKFLOW: "wfd_header_click_followWorkflow",
    HEADER_CLICK_COPY_LINK: "wfd_header_click_copyLink",
    HEADER_CLICK_VIEW_ACTIVITY_LOG: "wfd_header_click_viewActivityLog",
    HEADER_CLICK_PRINT_WORKFLOW: "wfd_header_click_printWorkflow",
    HEADER_CLICK_ARCHIVE_WORKFLOW: "wfd_header_click_archiveWorkflow",
    HEADER_CLICK_LINK_TO_PARENT: "wfd_header_click_linkToParent",
    HEADER_CLICK_UNLINK_FROM_PARENT: "wfd_header_click_unlinkFromParent",
    LEFTPANE_CLICK_OPEN_SWIMLANE: "wfd_leftPane_click_openSwimlane",
    LEFTPANE_CLICK_OPEN_STEP: "wfd_leftPane_click_openStep",
    LEFTPANE_CLICK_TOGGLE_SHOW_ALL_ON: "wfd_leftPane_click_toggleShowAllOn",
    LEFTPANE_CLICK_TOGGLE_SHOW_ALL_OFF: "wfd_leftPane_click_toggleShowAllOff",
    FOOTER_CLICK_SUBMIT_STEP: "wfd_footer_click_submitStep",
    FOOTER_CLICK_EDIT_STEP: "wfd_footer_click_editStep",
    FOOTER_CLICK_PREVIOUS_STEP: "wfd_footer_click_previousStep",
    FOOTER_CLICK_NEXT_STEP: "wfd_footer_click_nextStep",
    WF_SIDEPANE_FOOTER_CLICK_SUBMIT_STEP:
      "wfd_wfSidePane_footer_click_submitStep",
    WF_SIDEPANE_FOOTER_CLICK_EDIT_STEP: "wfd_wfSidePane_footer_click_editStep",
    WF_SIDEPANE_FOOTER_CLICK_NEXT_WORKFLOW:
      "wfd_wfSidePane_footer_click_nextWorkflow",
    WF_SIDEPANE_FOOTER_CLICK_PREVIOUS_WORKFLOW:
      "wfd_wfSidePane_footer_click_previousWorkflow",
    WF_SIDEPANE_FOOTER_CLICK_ADD_WORKFLOW:
      "wfd_wfSidePane_footer_click_addWorkflow",
    MAIN_STEP_CLICK_VIEW_COMMENTS: "wfd_main_step_click_viewComments",
    MAIN_FIELD_CLICK_VIEW_COMMENTS: "wfd_main_field_click_viewComments",
    MAIN_FIELD_CLICK_RECORDS_DUPLICATE_CHECK_INTEGRATION_BUTTON:
      "wfd_main_field_click_records_duplicate_check_integration_button",
    MAIN_STEP_CLICK_VIEW_VERSION_HISTORY:
      "wfd_main_step_click_viewVersionHistory",
    MAIN_STEP_CLICK_ASSIGN_STEP: "wfd_main_step_click_assignStep",
    MAIN_STEP_CLICK_UNASSIGN_STEP: "wfd_main_step_click_unassignStep",
    COMMENT_OVERVIEW_PANE_CLICK_COMMENT:
      "wfd_commentOverviewPane_click_Comment",
    COMMENT_DETAIL_PANE_CLICK_SUBMIT_COMMENT:
      "wfd_commentDetailPane_click_submitComment",
    COMMENT_DETAIL_PANE_CLICK_SUBSCRIBE_TO_THREAD:
      "wfd_commentDetailPane_click_subscribeToThread",
    COMMENT_DETAIL_PANE_CLICK_UNSUBSCRIBE_FROM_THREAD:
      "wfd_commentDetailPane_click_unsubscribeFromThread",
    COMMENT_DETAIL_PANE_CLICK_ATTACH_FILE:
      "wfd_commentDetailPane_click_attachFile",
    COMMENT_DETAIL_PANE_CLICK_OPEN_ADD_GROUP_MODAL:
      "wfd_commentDetailPane_click_openAddGroupModal",
    COMMENT_DETAIL_PANE_CLICK_ADD_GROUP: "wfd_commentDetailPane_click_addGroup",
    COMMENT_OVERVIEW_PANE_CLICK_UNREAD_TAB:
      "wfd_commentOverviewPane_click_unreadTab",
    COMMENT_OVERVIEW_PANE_CLICK_READ_TAB:
      "wfd_commentOverviewPane_click_readTab",
    ACTIVITY_LOGS_CLICK_VIEW_SIGNIFICANT_EVENTS:
      "wfd_workflowActivityLogs_click_viewSignificantEvents",
    ACTIVITY_LOGS_CLICK_VIEW_EDITS: "wfd_workflowActivityLogs_click_viewEdits",
    ACTIVITY_LOGS_CLICK_VIEW_VIEWS: "wfd_workflowActivityLogs_click_viewViews",
    ACTIVITY_LOGS_CLICK_VIEW_EMAILS:
      "wfd_workflowActivityLogs_click_viewEmails",
    ACTIVITY_LOGS_CLICK_VIEW_NOTIFICATIONS:
      "wfd_workflowActivityLogs_click_viewNotifications",
    ACTIVITY_LOGS_CLICK_VIEW_SCREENING:
      "wfd_workflowActivityLogs_click_viewScreening",
    ACTIVITY_LOGS_CLICK_DOWNLOAD_ACTIVITY_LOGS:
      "wfd_workflowActivityLogs_click_downloadActivityLogs"
  },
  workflowDetailFieldsEvents: {
    DATA_OBJECTS_SELECTION_TABLE_FIELD_SELECT:
      "dataObjectsSelectionTableField_select",
    DATA_OBJECTS_SELECTION_TABLE_FIELD_DESELECT:
      "dataObjectsSelectionTableField_deselect"
  },
  tasksPageEvents: {
    TASKS_CLICK_HEADERTAB: "tasks_click_headerTab",
    TASKS_CLICK_PROCESSFILTERS: "tasks_click_processFilters",
    TASKS_CLICK_SWIMLANE_VIEW: "tasks_click_swimlaneView",
    TASKS_CLICK_DEFAULT_LIST_VIEW: "tasks_click_defaultListView",
    TASKS_CLICK_WFFILTER_DROPDOWN: "tasks_click_wfFilterDropdown",
    TASKS_CLICK_SHOW_COMPLETED: "tasks_click_showCompletedProcesses_toggle",
    TASKS_CLICK_GROUPBY_TASKLANE: "tasks_click_groupByTasklaneDropdown",
    TASKS_CLICK_ADD_SAVED_FILTER: "tasks_click_addSavedFilter",

    PROCESS_DETAILS_CLICK_PROGRESS_MAP: "processDetails_click_progressMap",
    PROGRESS_MAP_CLICK_EXPAND_ALL_TOGGLE: "progressMap_click_expandAllToggle",
    PROGRESS_MAP_CLICK_SHOW_INACTIVE_STEPS_TOGGLE:
      "progressMap_click_showInactiveStepsToggle",
    PROGRESS_MAP_CLICK_TAB: "progressMap_click_tab",
    PROGRESS_MAP_CLICK_SWIMLANE: "progressMap_click_swimlane",
    PROGRESS_MAP_CLICK_STEP: "progressMap_click_step",
    PROGRESS_MAP_CLICK_ZOOM: "progressMap_click_zoom",

    // For tracking new progress map usage
    /**
     * - from?: "processDetails_sidebar" | "circularProgressButton"
     */
    PROGRESS_MAP_v2_OPEN: "progressMapv2_click_open",
    PROGRESS_MAP_v2_BACK_TO_WORKFLOW: "progressMapv2_click_backToWorkflow",
    PROGRESS_MAP_v2_CLICK_SWIMLANE: "progressMapv2_click_swimlane",
    PROGRESS_MAP_v2_CLICK_STEP: "progressMapv2_click_step",
    PROGRESS_MAP_v2_CLICK_GO_TO_TASKS: "progressMapv2_click_goToTasks",
    /**
     * - zoomInOrOut?: "in" | "out"
     */
    PROGRESS_MAP_v2_CLICK_ZOOM_IN_OUT: "progressMapv2_click_zoomInOut",
    PROGRESS_MAP_v2_CLICK_FIT_VIEW: "progressMapv2_click_fitView",

    TASKS_LEFT_PANE_CLICK_SELECT_WORKFLOW_TYPE:
      "tasks_leftPane_click_selectWorkflowType",
    TASKS_MAIN_CLICK_VIEW_MY_TASKS: "tasks_main_click_viewMyTasks",
    TASKS_MAIN_CLICK_VIEW_MY_GROUP_TASKS: "tasks_main_click_viewMyGroupTasks",
    TASKS_MAIN_CLICK_VIEW_DELEGATED_TASKS:
      "tasks_main_click_viewDelegatedTasks",
    TASKS_MAIN_CLICK_VIEW_ALL_TASKS: "tasks_main_click_viewAllTasks",
    TASKS_MY_TASKS_CLICK_OPEN_QUICK_FILTER_ACTIONS:
      "tasks_myTasks_click_openQuickFilterActions",
    TASKS_DELEGATED_TASKS_CLICK_OPEN_QUICK_FILTER_ACTIONS:
      "tasks_delegatedTasks_click_openQuickFilterActions",
    TASKS_MY_GROUP_TASKS_CLICK_OPEN_QUICK_FILTER_ACTIONS:
      "tasks_myGroupTasks_click_openQuickFilterActions",
    TASKS_ALL_TASKS_CLICK_OPEN_QUICK_FILTER_ACTIONS:
      "tasks_allTasks_click_openQuickFilterActions",
    TASKS_ALL_TASKS_CLICK_GROUP_BY_SWIMLANE:
      "tasks_allTasks_click_groupBySwimlane",
    TASKS_ALL_TASKS_CLICK_GROUP_BY_STATUS: "tasks_allTasks_click_groupByStatus",
    TASKS_MY_TASKS_WORKFLOW_TABLE_CLICK_OPEN_WORKFLOW:
      "tasks_myTasks_wfTable_click_openWorkflow",
    TASKS_MY_GROUPS_TASKS_WORKFLOW_TABLE_CLICK_OPEN_WORKFLOW:
      "tasks_myGroupTasks_wfTable_click_openWorkflow",
    TASKS_DELEGATED_TASKS_WORKFLOW_TABLE_CLICK_OPEN_WORKFLOW:
      "tasks_delegatedTasks_wfTable_click_openWorkflow",
    TASKS_ALL_TASKS_WORKFLOW_TABLE_CLICK_OPEN_WORKFLOW:
      "tasks_allTasks_wfTable_click_openWorkflow",
    TASKS_MY_TASKS_WF_TASKS_TABLE_CLICK_EXPAND_WORKFLOW:
      "tasks_myTasks_wfTasksTable_click_expandWorkflow",
    TASKS_MY_GROUPS_WF_TASKS_TABLE_CLICK_EXPAND_WORKFLOW:
      "tasks_myGroupTasks_wfTasksTable_click_expandWorkflow",
    TASKS_ALL_TASKS_WF_TASKS_TABLE_CLICK_EXPAND_WORKFLOW:
      "tasks_allTasks_wfTasksTable_click_expandWorkflow",
    TASKS_DELEGATED_TASKS_WF_TASKS_TABLE_CLICK_EXPAND_WORKFLOW:
      "tasks_delegatedTasks_wfTasksTable_click_expandWorkflow",
    TASKS_MY_TASKS_WF_TASKS_TABLE_CLICK_OPEN_STEP:
      "tasks_myTasks_wfTasksTable_click_openStep",
    TASKS_MY_GROUPS_WF_TASKS_TABLE_CLICK_OPEN_STEP:
      "tasks_myGroupTasks_wfTasksTable_click_openStep",
    TASKS_ALL_TASKS_WF_TASKS_TABLE_CLICK_OPEN_STEP:
      "tasks_allTasks_wfTasksTable_click_openStep",
    TASKS_DELEGATED_TASKS_WF_TASKS_TABLE_CLICK_OPEN_STEP:
      "tasks_delegatedTasks_wfTasksTable_click_openStep"
  },

  dashboardEvernts: {
    DASHBOARDS_LEFTPANE_CLICK_OPEN_DASHBOARD:
      "dashboards_leftPane_click_openDashboard",
    DASHBOARDS_LEFTPANE_CLICK_CREATE_DASHBOARD:
      "dashboards_leftPane_click_createDashboard",
    DASHBOARD_CLICK_SELECT_DASHBOARD: "dashboard_click_selectDashboard",
    DASHBOARD_CLICK_MOVE_DASHBOARD: "dashboard_click_moveDashboard",
    DASHBOARD_CLICK_DASHBOARD_JUMP: "dashboard__click_dashboardJump",
    DASHBOARD_CLICK_ADD_DASHBOARD: "dashboard_click_addDashboard",
    DASHBOARD_CLICK_REPORT_JUMP: "dashboard_click_reportJump",
    DASHBOARD_CLICK_ADD_REPORT: "dashboard_click_addReport",
    DASHBOARD_CLICK_DASHBOARD_ACTIONS: "dashboard_click_dashboardActions",
    DASHBOARD_REPORT_CLICK_WF: "dashboard_report_click_wf",
    DASHBOARD_REPORT_CLICK_WFACTIONS: "dashboard_report_click_wfActions",
    DASHBOARD_REPORT_CLICK_REPORT_ACTIONS:
      "dashboard_report_click_reportActions",
    DASHBOARD_REPORT_CLICK_FULLVIEW: "dashboard_report_click_fullView",
    DASHBOARD_REPORT_CLICK_FILTER: "dashboard_report_click_filter",
    DASHBOARD_REPORT_CLICK_SORT: "dashboard_report_click_sort",
    DASHBOARD_REPORT_CLICK_REFRESH: "dashboard_report_click_refresh",
    DASHBOARD_REPORT_CLICK_COMMENT: "dashboard_report_click_comment",

    DASHBOARD_ACTIONS_CLICK_EDIT_DASHBOARD:
      "dashboard_dashboardActionsDropdown_click_editDashboard",
    DASHBOARD_ACTIONS_CLICK_ACTIVITY_LOGS:
      "dashboard_dashboardActionsDropdown_activityLog",
    DASHBOARD_ACTIONS_CLICK_CHANGE_ARRAGEMENTS:
      "dashboard_dashboardActionsDropdown_click_changeArrangements",
    DASHBOARD_ACTIONS_CLICK_DELETE_DASHBOARD:
      "dashboard_dashboardActionsDropdown_click_deleteDashboard",
    DASHBOARD_ACTIONS_CLICK_EXPORT_AS:
      "dashboard_dashboardActionsDropdown_click_exportAs",
    DASHBOARD_ACTIONS_CLICK_DOWNLOAD_EXPORT:
      "dashboard_exportDashboardModal_click_download",

    DASHBOARD_REPORT_ACTION_CLICK_EDIT_REPORT:
      "dashboard_reportActionsDropdown_click_editReport",
    DASHBOARD_REPORT_ACTION_CLICK_MANAGE_SUBSCRIPTION:
      "dashboard_reportActionsDropdown_click_manageSubscriptions",
    DASHBOARD_REPORT_ACTION_CLICK_ACTIVITY_LOG:
      "dashboard_reportActionsDropdown_click_activityLog",
    DASHBOARD_REPORT_ACTION_CLICK_DELETE_REPORT:
      "dashboard_reportActionsDropdown_click_deleteReport",
    DASHBOARD_REPORT_ACTION_CLICK_EXPORT_TO_CSV:
      "dashboard_reportActionsDropdown_click_exportToCSV",
    DASHBOARD_REPORT_ACTION_CLICK_EXPORT_AS:
      "dashboard_reportActionsDropdown_click_exportAs",

    DASHBOARD_MANAGE_SUBSCRIPTIONS_CLICK_CREATE_SUBSCRIPTIONS:
      "dashboard_manageSubscriptionsModal_click_createSubscriptions",
    DASHBOARD_SUBSCRIBE_VIA_EMAIL_CLICK_SUBSCRIBE:
      "dashboard_subscribeViaEmailModal_click_Subscribe",
    DASHBOARD_SUBSCRIBE_VIA_SFTP_CLICK_SUBSCRIBE:
      "dashboard_subscribeViaSFTPModal_click_Subscribe"
  },

  reportEvents: {
    REPORTS_GEOMAP_PRECISION_CHANGE: "reports_geomap_precision_change",
    REPORTS_GEOMAP_SCALE_CHANGE: "reports_geomap_scale_change",

    ADD_REPORT_CLICK_VISUALISATION: "addReport_click_visulisationTab",
    ADD_REPORT_CLICK_DATA_TAB: "addReport_click_dataTab",
    ADD_REPORT_CLICK_VISUALISATION_TYPE: "addReport_click_visualisatoinType",
    ADD_REPORT_CLICK_CHART_TYPE: "addReport_click_chartType",
    ADD_REPORT_ONSAVE_CHECK_CONTAINS: "addReport_contains",
    ADD_REPORT_CLICK_SAVE_REPORT: "addReport_click_saveReport"
  },

  screeningReportEvents: {
    /**
     * Tracks when user successfully creates a screening report
     * - report_id: number
     * - dashboard_id: number
     */
    SCREENING_REPORT_CREATE_SUCCESS: "screeningReport_create_success",
    /**
     * Tracks when user successfully updates/edits a screening report
     * - report_id: number
     * - dashboard_id: number
     */
    SCREENING_REPORT_UPDATE_SUCCESS: "screeningReport_update_success",
    /**
     * Tracks when user exports a screening report to CSV
     * - report_id: number
     * - export_format: "csv"
     * - has_filters: boolean
     * - attributes_count: number
     */
    SCREENING_REPORT_EXPORT_CSV: "screeningReport_export_csv"
  },

  headerEvents: {
    TAB_CLICK: "header_tab_click",
    HEADER_CLICK_CREATE_NEW_DROPDOWN: "header_click_createNewDropdown",
    HEADER_CLICK_MENTIONS: "header_click_mentions",
    HEADER_CLICK_HELP_DROPDOWN: "header_click_helpDropdown",
    HEADER_CLICK_LANGUAGE_DROPDOWN: "header_click_languageDropdown",
    HEADER_CLICK_USERPROFILE_DROPDOWN: "header_click_userProfileDropdown",
    HEADER_CLICK_USERPROFILE_RECORDS: "header_click_userProfile_records"
  },

  navbar: {
    NAV_CLICK_SEARCH: "nav_click_search",
    NAV_CLICK_HOME: "nav_click_home",
    NAV_CLICK_DASHBOARDS: "nav_click_dashboards",
    NAV_CLICK_TASKS: "nav_click_tasks",
    NAV_CLICK_NOTIFICATIONS: "nav_click_notifications",
    NAV_CLICK_STUDIO: "nav_click_studio",
    NAV_CLICK_TABLEAU: "nav_click_tableau",
    NAV_CLICK_PROFILE: "nav_profile_click",
    NAV_PROFILE_CLICK_MYPROFILE: "nav_profile_click_viewMyProfile",
    NAV_PROFILE_CLICK_SETTINGS: "nav_profile_click_settings",
    NAV_PROFILE_CLICK_SCHEDULED_REPORTS:
      "nav_profile_click_viewMyScheduledReports",
    NAV_PROFILE_CLICK_INSTANCE_SETTINGS:
      "nav_profile_click_viewInstanceSettings",
    NAV_PROFILE_LANGUAGE_CLICK_SWITCH_LANGUAGE:
      "nav_profile_language_click_switchLanguage",
    NAV_PROFILE_VIEW_AS_CLICK_EXTERNAL_USER:
      "nav_profile_viewAs_click_viewAsExternalUser",
    NAV_PROFILE_VIEW_AS_CLICK_CERTA_USER:
      "nav_profile_viewAs_click_viewAsCertaUser",
    NAV_PROFILE_HELP_CLICK_SUPPORT_WORKFLOW:
      "nav_profile_help_click_startCertaSupportWorkflow",
    NAV_PROFILE_HELP_CLICK_OPEN_USER_HELP_LINK:
      "nav_profile_help_click_openUserHelpLink",
    NAV_PROFILE_IMPORT_WORKFLOWS: "nav_profile_importWorkflows_click"
  },

  notificationEvents: {
    NOTIFICATIONS_LEFTPANE_ALL_NOTIFICATIONS_CLICK_OPEN_COMMENT_NOTIFICATION:
      "notifications_leftPane_allNotifications_click_openCommentNotification",
    NOTIFICATIONS_LEFTPANE_ALL_NOTIFICATIONS_CLICK_OPEN_SUBSCRIBED_THREAD:
      "notifications_leftPane_allNotifications_click_openSubscribedThread",
    NOTIFICATIONS_LEFTPANE_ALL_NOTIFICATIONS_CLICK_TOGGLE_UNREAD_OFF:
      "notifications_leftPane_allNotifications_click_toggleUnreadOff",
    NOTIFICATIONS_LEFTPANE_ALL_NOTIFICATIONS_CLICK_TOGGLE_UNREAD_ON:
      "notifications_leftPane_allNotifications_click_toggleUnreadOn",
    NOTIFICATIONS_HEADER_CLICK_MY_SUBSCRIPTIONS:
      "notifications_header_click_mySubscriptions",
    NOTIFICATIONS_HEADER_CLICK_ALL_NOTIFICATIONS:
      "notifications_header_click_allNotifications"
  },

  homepageEvents: {
    HOME_CLICK_STARTWORKFLOW: "home_click_startWorkflow",
    HOME_CLICK_BROWSE_ALL_WORKFLOWS: "home_click_browseAllWorkflows",
    HOME_BROWSE_ALL_CLICK_START_WORKFLOW: "home_browseAll_click_startWorkflow",
    HOME_CLICK_SEARCH: "home_click_search",
    HOME_CREATE_WORKFLOW_CLICK: "home_createWorkflow_click_<button>",
    HOME_RECENTLY_VIEWED_CLICK: "home_recentlyViewed_click_<workflow><button>",
    HOME_CLICK_FILTER: "home_click_:filterKey",
    HOME_FILTER_CLICK_WORKFLOW: "home_:filterKey_click_workflow",
    HOME_FILTER_CLICK_WORKFLOW_ACTION:
      "home_:filterKey_workflow_click_:actionName",
    HOME_CLICK_FOLLOWING: "home_following_click_<workflow><workflow><button>",
    HOME_CLICK_RECENTLY_VIEWED:
      "home_click_waitingOnYouhome_click_requestedByYou",
    HOME_CLICK_WAITINGONYOU: "home_click_waitingOnYouhome_click_requestedByYou",
    HOME_CLICK_REQUESTEDBYYOU: "home_click_requestedByYou",
    HOME_CLICK_COMMENT: "home_click_comment",
    HOME_CLICK_WFACTIONS: "home_click_WFActions",
    HOME_CLICK_MORE_ACTIONS: "search_click_moreResults",
    HOME_CLICK_RECENT_SEARCHES: "search_click_recentSearches",
    HOME_CLICK_SEARCH_RESULTS: "search_click_searchResults",
    HOME_CLICK_GLOBAL_SEARCH: "home_click_globalSearch",
    HOME_SEARCH_KEYWORD: "search_keyword",
    HOME_SEARCH_RETURN_KEY: "search_keypress_returnKey",
    HOME_SEARCH_CATEGORY_CLICK: "search_click_category",
    HOME_SEARCH_TOOLTIP_SHOWN: "search_tooltipShown",

    // New "My workflows" table events
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_WORKFLOW:
      "homepage_myWorkflows_table_click_workflow",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_WAITINGONME:
      "homepage_myWorkflows_table_click_waitingOnMe",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_REQUESTEDBYME:
      "homepage_myWorkflows_table_click_requestedByMe",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_RECENTLYVIEWED:
      "homepage_myWorkflows_table_click_recentlyViewed",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_FOLLOWING:
      "homepage_myWorkflows_table_click_following",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_WORKFLOW_ACTION_COMMENT:
      "homepage_myWorkflows_table_click_workflowAction_comment",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_FILTER:
      "homepage_myWorkflows_table_click_filter",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_SORT:
      "homepage_myWorkflows_table_click_sort",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_TASKS:
      "homepage_myWorkflows_table_click_tasks",
    HOMEPAGE_MY_WORKFLOWS_TABLE_CLICK_PROGRESS_MAP:
      "homepage_myWorkflows_table_click_progressMap"
  },

  loginPageEvents: {
    CERTA_TEAM_LOGIN: "login_click_LoginWithCertaTeamButton",
    LOGIN_WITH_EMAIL_AND_PASSWORD:
      "login_click_loginUsingEmailAndPasswordButton",
    LOGIN_WITH_EMAIL_AND_PASSWORD_ERROR:
      "login_error_loginUsingEmailAndPasswordButton",
    LOGIN_MFA_PIN_ERROR: "login_error_loginUsingMFAButton",
    LOGIN_EMAIL_PASSWORD_SUBMIT: "login_click_loginButton",
    REQUEST_OTP: "login_click_requestOTPButton",
    OTP_SENT: "login_otpsent_requestOTPButton",
    RESEND_OTP: "login_click_resendOTPButton",
    OTP_SUBMITTED: "login_OTPsubmitted_loginButton",
    OTP_ERROR: "login_otpError_loginButton",
    OTP_VERIFIED: "login_OTPverified_loginButton",
    LOGIN_SUCCESSFUL: "login_successful_loginButton",
    LOGOUT: "logOut_logout_logoutButton",
    LOGIN_CLICK_CHANGE_LANGUAGE_DROPDOWN: "login_click_changeLanguageDropdown",
    LOGIN_CHANGE_LANGUAGE_DROPDOWN:
      "login_changeLanguageDropdown_click_language"
  },

  heyCertaEvents: {
    HEY_CERTA_CLICKED: "studio_click_heyCerta",
    PROMPT_SUCCESS: "studio_promptSuccessful_heyCerta",
    PROMPT_SKIPPED: "studio_promptSkipped_heyCerta",
    PROMPT_FAILED: "studio_promptFailed_heyCerta",
    PROMPT_FOLLOW_UP: "studio_promptFollowUp_heyCerta",
    PROMPT_ACTION_REQUIRED: "studio_promptActionRequired_heyCerta",
    CHOSEN_FOLLOW_UP: "studio_chosenFollowUp_heyCerta",
    USER_PROMPT_FEEDBACK: "studio_promptFeedback_heyCerta"
  },

  designAIEvents: {
    // For tracking Design AI impressions
    /**
     * - is_opened: boolean
     */
    DESIGNAI_OPEN_CLOSE: "designai_openClose",

    // For tracking slash commands usage
    /**
     * - slash_command_id: string
     * - selected_component_type?: "Swimlane" | "Step" | "Field"
     */
    DESIGNAI_SLASH_COMMAND_RUN: "designai_slashCommand_run",
    /**
     * - opened_from: "landing_page" | "keyboard_slash"
     */
    DESIGNAI_SLASH_COMMAND_DROPDOWN_OPEN: "designai_slashCommand_dropdown_open",
    /**
     * - slash_command_id: string
     */
    DESIGNAI_SLASH_COMMAND_VIEW_EXAMPLE_CLICK:
      "designai_slashCommand_viewExample_click",

    // For tracking landing page suggestion usage
    /**
     * - suggestion_id: string
     * - selected_component_type?: "Swimlane" | "Step" | "Field"
     */
    DESIGNAI_LANDING_PAGE_SUGGESTION_RUN: "designai_landingPage_suggestion_run",

    // For tracking Design AI user guide navigations
    DESIGNAI_USER_GUIDE_CLICK: "designai_userGuide_click",

    // For tracking how many times incontext mode is being disabled
    DESIGNAI_INCONTEXT_DISABLE: "designai_inContext_disable",

    // For tracking general feedback impressions and what flow led them their
    /**
     * - is_opened: boolean
     */
    DESIGNAI_FEEDBACK_GENERAL_CLICK: "designai_feedbackGeneral_click",
    /**
     * - rating: number (1-5)
     * - usability?: "easy" | "moderate" | "difficult"
     * - velocity?: "improved" | "no_impact" | "reduced"
     * - is_useful?: boolean
     * - feedback?: string
     */
    DESIGNAI_FEEDBACK_GENERAL_FORM_SUBMIT:
      "designai_feedbackGeneral_form_submit",

    // For tracking interaction feedback usage
    /**
     * - like_or_dislike: "like" | "dislike"
     */
    DESIGNAI_FEEDBACK_INTERACTION_CLICK: "designai_feedbackInteraction_click",
    /**
     * - feedback: string
     */
    DESIGNAI_FEEDBACK_INTERACTION_FORM_SUBMIT:
      "designai_feedbackInteraction_form_submit",

    /**
     * - from_outside_studio: boolean
     * - is_brd_mode: boolean
     * - changes_count: number
     * - patches_count: number
     * - has_reprompted: boolean
     */
    DESIGNAI_TASK_LOOKS_GOOD: "designai_task_looks_good",
    /**
     * - from_outside_studio: boolean
     * - changes_count: number
     * - patches_count: number
     */
    DESIGNAI_TASK_NEEDS_CHANGES: "designai_task_needs_changes",
    /**
     * - sub_prompt: string
     * - intent: string
     * - success_message: string
     * - has_changes: boolean
     */
    DESIGNAI_SUBTASK_SUCCESS: "designai_subtask_success",
    /**
     * - sub_prompt: string
     * - intent: string
     * - skip_reason: string
     */
    DESIGNAI_SUBTASK_SKIP: "designai_subtask_skip",

    // For tracking Junior CA process indexing usage
    DESIGNAI_JUNIOR_CA_PROCESS_INDEXING_CLICK:
      "designai_juniorCA_processIndexing_click"
  },

  designAIEventsV3: {
    // For tracking new conversation button usage
    /**
     * - from_outside_studio: boolean
     */
    DESIGNAI_NEW_CONVERSATION_CLICK: "designai_newConversation_click",

    // For tracking thumbs up/down feedback in footer
    /**
     * - is_thumbs_up: boolean
     * - message_id: string
     * - turn_id: string
     * - conversation_id: string
     */
    DESIGNAI_CLICK_BUTTON_THUMBS_FEEDBACK:
      "designai_click_button_thumbs_feedback",
    /**
     * - reasons_count: number
     * - has_comment: boolean
     * - message_id: string
     * - turn_id: string
     * - conversation_id: string
     */
    DESIGNAI_SUBMIT_FORM_THUMBS_FEEDBACK:
      "designai_submit_form_thumbs_feedback",
    /**
     * - message_id: string
     * - turn_id: string
     */
    DESIGNAI_CLICK_BUTTON_THUMBS_FEEDBACK_BACK:
      "designai_click_button_thumbs_feedback_back",

    // For tracking chat session ended feedback
    /**
     * - conversation_id: string
     * - turn_id: string
     */
    DESIGNAI_CLICK_BUTTON_CHAT_SESSION_ENDED_FEEDBACK:
      "designai_click_button_chat_session_ended_feedback",
    /**
     * - reasons_count: number
     * - has_comment: boolean
     * - conversation_id: string
     * - turn_id: string
     */
    DESIGNAI_SUBMIT_FORM_CHAT_SESSION_ENDED_FEEDBACK:
      "designai_submit_form_chat_session_ended_feedback",
    /**
     * - conversation_id: string
     * - turn_id: string
     */
    DESIGNAI_CLICK_BUTTON_CHAT_SESSION_ENDED_FEEDBACK_BACK:
      "designai_click_button_chat_session_ended_feedback_back",

    // For tracking new chat interactions
    /**
     * - has_pending_feedback: boolean
     * - conversation_id: string
     * - turn_id: string
     */
    DESIGNAI_CLICK_BUTTON_NEW_CHAT: "designai_click_button_new_chat",

    // For tracking component selection mode interactions
    /**
     * - is_enabled: boolean
     */
    DESIGNAI_TOGGLE_BUTTON_INSPECT_COMPONENT_SELECTION:
      "designai_toggle_button_inspect_component_selection",

    // For tracking attachment interactions
    /**
     * - attachment_category: string
     * - is_guided_upload: boolean
     */
    DESIGNAI_SELECT_DROPDOWN_ATTACHMENT_CATEGORY:
      "designai_select_dropdown_attachment_category",
    /**
     * - files_count: number
     * - attachment_category: string
     * - total_file_size: number
     * - files_types: string[]
     */
    DESIGNAI_UPLOAD_FILES_ATTACHMENT: "designai_upload_files_attachment",

    // For tracking task execution results
    /**
     * - user_prompt: string
     * - selected_component_type: null | "Swimlane" | "Step" | "Field"
     * - is_junior_ca: boolean
     * - from_outside_studio: boolean
     */
    DESIGNAI_USER_PROMPT_SEND: "designai_userPrompt_send",
    /**
     * - has_changes: boolean
     * - is_task_breakdown_ui_shown: boolean
     */
    DESIGNAI_TASK_SUCCESS: "designai_task_success",
    /**
     * - failed_sub_prompt: string
     * - failed_intent: string
     * - failure_reason: string
     * - is_failure_user_triggered: boolean
     * - is_task_breakdown_ui_shown: boolean
     */
    DESIGNAI_TASK_FAIL: "designai_task_fail",
    // For tracking followups usage
    /**
     * - target_type: string
     * - question: string
     * - intent: string
     * - is_task_breakdown_ui_shown: boolean
     * - from_outside_studio: boolean
     */
    DESIGNAI_FOLLOWUP_RAISE: "designai_followup_raise",
    /**
     * - target_type: string
     * - question: string
     * - followup_response: string
     * - intent: string
     * - is_task_breakdown_ui_shown: boolean
     * - from_outside_studio: boolean
     */
    DESIGNAI_FOLLOWUP_RESPONSE: "designai_followup_response",

    // For tracking file followup usage
    /**
     * - sample_file_label: string
     */
    DESIGNAI_FOLLOWUP_FILE_SAMPLE_FILE_DOWNLOAD:
      "designai_followupFile_sampleFile_download",
    /**
     * - file_mime_type: string
     * - file_size_in_bytes: number
     * - from_outside_studio: boolean
     */
    DESIGNAI_FOLLOWUP_FILE_UPLOAD: "designai_followupFile_upload",

    // For tracking action buttons usage
    /**
     * - skip_reason: string
     * - conversation_id: string
     */
    DESIGNAI_SKIP_FOLLOWUP_CLICK: "designai_actionButton_skipFollowup_click",
    /**
     * - from_outside_studio: boolean
     */
    DESIGNAI_CANCEL_EXECUTION_CLICK:
      "designai_actionButton_cancelExecution_click",
    DESIGNAI_UNDO_CHANGES_CLICK: "designai_actionButton_undoChanges_click",

    // For tracking integration config modal actions
    /**
     * - api_type: string
     * - name: string
     */
    DESIGNAI_INTEGRATION_CONFIG_SAVE: "designai_integrationConfig_save",
    /**
     * - error_message: string
     * - api_type: string
     * - name: string
     * - form_values: SNAP API form values
     */
    DESIGNAI_INTEGRATION_CONFIG_SAVE_ERROR:
      "designai_integrationConfig_saveError",
    DESIGNAI_INTEGRATION_CONFIG_CANCEL: "designai_integrationConfig_cancel",
    DESIGNAI_SHOW_MODAL_CONFIRM_CANCELLATION:
      "designai_show_modal_confirm_cancellation",
    /**
     * - reason: "stop_task_triggered" | "conversation_failed" | "free_text_followup_response_undefined" | "interactive_followup_response_undefined" | "solution_followup_response_undefined" | "last_response_not_found" | "error_caught"
     */
    DESIGNAI_TRIGGER_ROLLBACK_TO_LAST_CHECKPOINT:
      "designai_trigger_rollback_to_last_checkpoint",
    DESIGNAI_SHOW_MODAL_ROLLBACK_TO_CHECKPOINT_CONFIRMATION:
      "designai_show_modal_rollback_to_checkpoint_confirmation",
    /**
     * - conversation_id: string
     * - turn_id: string
     */
    DESIGNAI_CLICK_BUTTON_ROLLBACK_TO_CHECKPOINT:
      "designai_click_button_rollback_to_checkpoint",
    /**
     * - rollback_trigger_by: "user" | "system"
     * - conversation_id: string
     * - turn_id: string
     * - error_message: string
     */
    DESIGNAI_ERROR_ROLLBACK: "designai_error_rollback",
    /**
     * - conversation_id: string
     * - turn_id: string
     */
    DESIGNAI_SUCCESS_ROLLBACK: "designai_success_rollback",
    /**
     * - expanded: boolean
     */
    DESIGNAI_INTERACT_CHECKPOINT_REVERTED:
      "designai_interact_checkpoint_reverted",
    /**
     * - stage: "thinking" | "building" | "executing"
     * - expanded: boolean
     * - expandable: boolean
     */
    DESIGNAI_INTERACT_ITEM_COMMAND: "designai_interact_item_command",
    /**
     * - stage: "thinking" | "building" | "executing"
     * - expanded: boolean
     */
    DESIGNAI_INTERACT_TIMELINE_COMMAND: "designai_interact_timeline_command",
    /**
     * - stage: "thinking" | "building" | "executing"
     * - expanded: boolean
     */
    DESIGNAI_CLICK_BUTTON_COMMAND_TIMELINE_SHOW_MORE:
      "designai_click_button_command_timeline_show_more",
    /**
     * - component_tag: string
     */
    DESIGNAI_CLICK_ENTITY_TAG: "designai_click_entity_tag",
    /**
     * - component_tag: string
     * - type: "tag" | "rule"
     */
    DESIGNAI_REMOVE_ENTITY_TAG: "designai_remove_entity_tag",
    /**
     * - response_type: "free_text"
     */
    DESIGNAI_SUBMIT_RESPONSE_FOLLOWUP: "designai_submit_response_followup",

    DESIGNAI_CLICK_BUTTON_CREATE_INTEGRATION_CONFIG:
      "designai_click_button_create_integration_config",
    DESIGNAI_CLICK_BUTTON_SEE_INTEGRATION_CONFIG_DETAILS:
      "designai_click_button_see_integration_config_details",
    /**
     * - type: "use_ui"
     * - sub_type: "integration_config"
     * - is_expanded: boolean
     */
    DESIGNAI_TOGGLE_FORM_USE_UI_COLLAPSE:
      "designai_toggle_form_use_ui_collapse",

    /**
     * - is_fast_mode_enabled: boolean
     */
    DESIGNAI_TOGGLE_FAST_MODE: "designai_toggle_fast_mode"
  },

  formBuilderEvents: {
    // Vertical Wizard Events
    /**
     * - form_name: string
     * - header_text: string
     */
    FORMBUILDER_VERTICAL_WIZARD_HEADER_CLICK:
      "formBuilder_verticalWizard_header_click",
    /**
     * - form_name: string
     * - header_text: string
     */
    FORMBUILDER_VERTICAL_WIZARD_EDIT_CLICK:
      "formBuilder_verticalWizard_edit_click",
    /**
     * - form_name: string
     * - header_text: string
     */
    FORMBUILDER_VERTICAL_WIZARD_CANCEL_EDIT_CLICK:
      "formBuilder_verticalWizard_cancelEdit_click"
  },

  riskAIFieldEvents: {
    // Main RiskAIField tab switching
    /**
     * - tab_name: "summary" | "soc2details" | "documents" | "fourthParties" | "locations"
     */
    RISKAI_TAB_SWITCH: "riskAI_tab_switch",

    // RiskSummary component events
    /**
     * - is_expanded: boolean
     */
    RISKAI_TOGGLE_DETAILED_ANALYSIS: "riskAI_toggle_detailed_analysis",
    /**
     * - filter_status: "TRUE" | "FALSE" | "FURTHER REVIEW" | "NO EVIDENCE FOUND" | null
     */
    RISKAI_CONTROL_STATUS_FILTER: "riskAI_control_status_filter",
    /**
     * - view_type: "assessmentResult" | "riskDomain"
     */
    RISKAI_VIEW_TYPE_SWITCH: "riskAI_view_type_switch",

    // Feedback events
    /**
     * - attribute_name: string
     * - control_id: string
     */
    RISKAI_FEEDBACK_THUMBS_UP: "riskAI_feedback_thumbs_up",
    /**
     * - attribute_name: string
     * - control_id: string
     */
    RISKAI_FEEDBACK_THUMBS_DOWN: "riskAI_feedback_thumbs_down",
    /**
     * - feedback_category: string
     * - feedback_text_length: number
     */
    RISKAI_FEEDBACK_MODAL_SUBMIT: "riskAI_feedback_modal_submit",
    /**
     * - had_content: boolean
     */
    RISKAI_FEEDBACK_MODAL_CLOSE: "riskAI_feedback_modal_close",

    // Table expand/collapse events
    /**
     * - table_type: "assessment_result" | "risk_domain" | "controls"
     * - first_column_value: string
     */
    RISKAI_TABLE_ROW_EXPAND: "riskAI_table_row_expand",
    /**
     * - table_type: "assessment_result" | "risk_domain" | "controls"
     * - first_column_value: string
     */
    RISKAI_TABLE_ROW_COLLAPSE: "riskAI_table_row_collapse",

    // Documents component events
    /**
     * - filter_status: "Expired" | "Expiring Soon" | "Not Available" | "Valid" | null
     */
    RISKAI_DOCUMENT_STATUS_FILTER: "riskAI_document_status_filter",

    // Citations modal events
    /**
     * - source_component: "soc2_exceptions" | "fourth_parties" | "locations" | "attributes" | "cuecs"
     */
    RISKAI_CITATIONS_OPEN: "riskAI_citations_open",
    /**
     * - source_component: string
     * - citations_count: number
     */
    RISKAI_CITATIONS_CLOSE: "riskAI_citations_close",
    /**
     * - citation_page: number
     * - citation_section: string
     */
    RISKAI_CITATION_CLICK: "riskAI_citation_click"
  },

  snapAPIEvents: {
    // For tracking SnapAPI user interactions
    /**
     * - tab_name: "params" | "authorization" | "headers" | "body"
     */
    SNAPAPI_TAB_CHANGE: "snapapi_tab_change",
    /**
     * - previous_name: string
     * - new_name: string
     * - previous_tag: string
     * - new_tag: string
     * - name_length: number
     */
    SNAPAPI_NAME_CHANGE: "snapapi_name_change",
    /**
     * - previous_token_id: string
     * - new_token_id: string
     * - auth_type: string
     * - is_clearing_selection: boolean
     * - is_selecting_token: boolean
     */
    SNAPAPI_INTEGRATION_TOKEN_CHANGE: "snapapi_integrationToken_change",
    /**
     * - method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH" | "HEAD" | "OPTIONS"
     */
    SNAPAPI_HTTP_METHOD_CHANGE: "snapapi_httpMethod_change",
    /**
     * - auth_type: "No Auth" | "Basic Auth" | "Integration Token" | "API Key" | "Bearer Token"
     */
    SNAPAPI_AUTH_TYPE_CHANGE: "snapapi_authType_change",
    /**
     * - body_type: "form-data" | "x-www-form-urlencoded" | "application/json" | "text/xml"
     */
    SNAPAPI_BODY_TYPE_CHANGE: "snapapi_bodyType_change",
    /**
     * - param_key: string
     * - param_value: string
     * - is_enabled: boolean
     * - is_auto_generated: boolean
     * - total_params: number
     */
    SNAPAPI_PARAM_ADD: "snapapi_param_add",
    /**
     * - param_key: string
     * - param_value: string
     * - was_enabled: boolean
     * - was_auto_generated: boolean
     * - remaining_params: number
     */
    SNAPAPI_PARAM_DELETE: "snapapi_param_delete",
    /**
     * - param_key: string
     * - param_value: string
     * - is_enabled: boolean
     * - is_auto_generated: boolean
     */
    SNAPAPI_PARAM_TOGGLE: "snapapi_param_toggle",
    /**
     * - mode: "table" | "text"
     * - previous_mode: "table" | "text"
     * - current_params_count: number
     * - enabled_params_count: number
     */
    SNAPAPI_PARAMS_BULK_MODE_TOGGLE: "snapapi_params_bulkMode_toggle",
    /**
     * - bulk_text_lines: number
     * - previous_params_count: number
     * - bulk_text_preview: string
     */
    SNAPAPI_PARAMS_BULK_APPLY: "snapapi_params_bulk_apply",
    /**
     * - header_key: string
     * - header_value: string (masked if sensitive)
     * - is_enabled: boolean
     * - is_auto_generated: boolean
     * - is_masked: boolean
     * - total_headers: number
     */
    SNAPAPI_HEADER_ADD: "snapapi_header_add",
    /**
     * - header_key: string
     * - header_value: string (masked if sensitive)
     * - was_enabled: boolean
     * - was_auto_generated: boolean
     * - was_masked: boolean
     * - remaining_headers: number
     */
    SNAPAPI_HEADER_DELETE: "snapapi_header_delete",
    /**
     * - header_key: string
     * - header_value: string (masked if sensitive)
     * - is_enabled: boolean
     * - is_auto_generated: boolean
     * - is_masked: boolean
     */
    SNAPAPI_HEADER_TOGGLE: "snapapi_header_toggle",
    /**
     * - mode: "table" | "text"
     * - previous_mode: "table" | "text"
     * - current_headers_count: number
     * - enabled_headers_count: number
     * - auto_generated_headers_count: number
     */
    SNAPAPI_HEADERS_BULK_MODE_TOGGLE: "snapapi_headers_bulkMode_toggle",
    /**
     * - bulk_text_lines: number
     * - previous_headers_count: number
     * - bulk_text_preview: string
     */
    SNAPAPI_HEADERS_BULK_APPLY: "snapapi_headers_bulk_apply",
    SNAPAPI_HEADERS_HIDE_AUTO_GENERATED: "snapapi_headers_hideAutoGenerated",
    /**
     * - location: "Header" | "Query Params"
     */
    SNAPAPI_API_KEY_LOCATION_CHANGE: "snapapi_apiKey_location_change",
    /**
     * - api_key_name: string
     * - is_visible: boolean
     */
    SNAPAPI_API_KEY_TOGGLE_VALUE_VISIBILITY:
      "snapapi_apiKey_toggle_value_visibility",

    SNAPAPI_CURL_IMPORT_OPEN: "snapapi_curlImport_open",
    /**
     * - curl_command_length: number
     * - has_error: boolean
     * - error_message?: string
     */
    SNAPAPI_CURL_IMPORT_SUBMIT: "snapapi_curlImport_submit",
    /**
     * - curl_command_length: number
     * - has_error: boolean
     * - error_message?: string
     */
    SNAPAPI_CURL_IMPORT_PASTE: "snapapi_curlImport_paste",
    SNAPAPI_CURL_IMPORT_CANCEL: "snapapi_curlImport_cancel",
    /**
     * - dynamic_value_name: string
     * - dynamic_value_type: string
     * - total_dynamic_values: number
     */
    SNAPAPI_JSON_DYNAMIC_VALUE_ADD: "snapapi_jsonDynamicValue_add",
    /**
     * - dynamic_value_name: string
     * - dynamic_value_type: string
     * - remaining_dynamic_values: number
     */
    SNAPAPI_JSON_DYNAMIC_VALUE_DELETE: "snapapi_jsonDynamicValue_delete",
    /**
     * - dynamic_value_name: string
     */
    SNAPAPI_JSON_DYNAMIC_VALUE_INSERT: "snapapi_jsonDynamicValue_insert",
    /**
     * - view_mode: "editor" | "dynamic"
     * - previous_view_mode: "editor" | "dynamic"
     */
    SNAPAPI_JSON_BODY_VIEW_MODE_CHANGE: "snapapi_jsonBodyViewMode_change",

    /**
     * - param_key: string
     * - param_value: string
     * - param_type: "text" | "file"
     * - is_enabled: boolean
     * - total_form_data_params: number
     */
    SNAPAPI_FORM_DATA_PARAM_ADD: "snapapi_formDataParam_add",
    /**
     * - param_key: string
     * - param_value: string
     * - param_type: "text" | "file"
     * - was_enabled: boolean
     * - remaining_form_data_params: number
     */
    SNAPAPI_FORM_DATA_PARAM_DELETE: "snapapi_formDataParam_delete",
    /**
     * - param_key: string
     * - param_value: string
     * - param_type: "text" | "file"
     * - is_enabled: boolean
     */
    SNAPAPI_FORM_DATA_PARAM_TOGGLE: "snapapi_formDataParam_toggle",

    /**
     * - param_key: string
     * - param_value: string
     * - is_enabled: boolean
     * - total_form_url_encoded_params: number
     */
    SNAPAPI_FORM_URL_ENCODED_PARAM_ADD: "snapapi_formUrlEncodedParam_add",
    /**
     * - param_key: string
     * - param_value: string
     * - was_enabled: boolean
     * - remaining_form_url_encoded_params: number
     */
    SNAPAPI_FORM_URL_ENCODED_PARAM_DELETE: "snapapi_formUrlEncodedParam_delete",
    /**
     * - param_key: string
     * - param_value: string
     * - is_enabled: boolean
     */
    SNAPAPI_FORM_URL_ENCODED_PARAM_TOGGLE: "snapapi_formUrlEncodedParam_toggle",

    /**
     * - param_key: string
     * - param_value: string
     * - param_location: "header" | "body"
     * - is_enabled: boolean
     * - total_dynamic_token_params: number
     */
    SNAPAPI_DYNAMIC_TOKEN_PARAM_ADD: "snapapi_dynamicTokenParam_add",
    /**
     * - param_key: string
     * - param_value: string
     * - param_location: "header" | "body"
     * - was_enabled: boolean
     * - remaining_dynamic_token_params: number
     */
    SNAPAPI_DYNAMIC_TOKEN_PARAM_DELETE: "snapapi_dynamicTokenParam_delete",
    /**
     * - param_key: string
     * - param_value: string
     * - param_location: "header" | "body"
     * - is_enabled: boolean
     */
    SNAPAPI_DYNAMIC_TOKEN_PARAM_TOGGLE: "snapapi_dynamicTokenParam_toggle",

    /**
     * - header_key: string
     * - is_visible: boolean
     * - is_sensitive: boolean
     */
    SNAPAPI_HEADER_VISIBILITY_TOGGLE: "snapapi_header_visibility_toggle",

    /**
     * - param_key: string
     * - validation_error: string
     * - param_type: "query" | "header" | "form_data" | "form_url_encoded"
     */
    SNAPAPI_PARAM_VALIDATION_ERROR: "snapapi_param_validation_error",

    /**
     * - operation_type: "params" | "headers"
     * - bulk_text_lines: number
     * - success_count: number
     * - error_count: number
     */
    SNAPAPI_BULK_OPERATION_APPLY: "snapapi_bulkOperation_apply",

    /**
     * - content_type: "header" | "param"
     * - auto_generated_count: number
     * - total_count: number
     */
    SNAPAPI_AUTO_GENERATED_CONTENT_TOGGLE: "snapapi_autoGeneratedContent_toggle"
  },

  jsonEditorEvents: {
    JSON_EDITOR_COPY_CLICK: "jsonEditor_copy_click",
    JSON_EDITOR_FORMAT_CLICK: "jsonEditor_format_click"
  },

  studioEvents: {
    /**
     * - name: string
     * - toggle_to: "facts_field" | "single_field",
     */
    STUDIO_TOGGLE_FACTS_WRAPPER_FIELD: "studio_toggle_facts_wrapper_field",
    /**
     * - name: string
     */
    STUDIO_CREATE_NEW_OPTION_FACTS_WRAPPER_FIELD:
      "studio_create_new_option_facts_wrapper_field",
    STUDIO_CLICK: "studio_click_general",
    STUDIO_CLICK_DRAWER: "studio_click_drawer",

    // Left Toolbar Events
    STUDIO_LEFT_MENU_CLICK: "studio_click_leftMenu",
    STUDIO_CLICK_LEFT_TOOLBAR: "studio_click_leftToolbar",
    STUIO_CLICK_TEMPLATE_TAB: "studio_click_templateType",
    STUDIO_TEMPLATE_ITEM_CLICK: "studio_click_templateItem",
    STUDIO_ADDFIELD_INPUT_SEARCH: "studio_click_addFieldInputSearch",
    // Process Editor Header events
    STUDIO_HEADER_APP_ICON_CLICK: "studio_click_processEditorSubheaderAppIcon",
    STUDIO_HEADER_SEARCH_ICON_CLICK:
      "studio_click_processEditorSubheaderSearchIcon",
    STUDIO_HEADER_PROCESS_SETTINGS_DROPDOWN_CLICK:
      "studio_click_processEditorSubheaderProcessSettingsDropdown",
    STUDIO_HEADER_PROCESS_SETTINGS_DROPDOWN_ITEM_CLICK:
      "studio_click_processEditorSubheaderProcessSettingsDropdownItem"
  },

  studioWebGLEvents: {
    STUDIO_WEBGL_CLICK_NAVBAR_STUDIO_LOGO: "studiowebgl_click_studiowebglIcon",
    STUDIO_WEBGL_CLICK_NAVBAR_SEARCH: "studiowebgl_click_navbarSearch",
    STUDIO_WEBGL_SEARCH_NAVBAR_SEARCH: "studiowebgl_search_navbarSearch",
    STUDIO_WEBGL_CLICK_SEARCH_MENU_LIST: "studiowebgl_click_searchMenuList",
    STUDIO_WEBGL_CLICK_NAVBAR_SUBMIT:
      "studiowebgl_navbarClick_submitChangesButton",
    STUDIO_WEBGL_CLICK_NAVBAR_EDIT: "studiowebgl_navbarClick_editButton",
    STUDIO_WEBGL_CLICK_NAVBAR_DROPDOWN: "studiowebgl_click_navbarDropdown",
    STUDIO_WEBGL_CLICK_BOTTOM_NAVBAR_COLLAPSE_ALL:
      "studiowebgl_click_bottomnav_collapseAll",
    STUDIO_WEBGL_CLICK_BOTTOM_NAVBAR_EXPAND_ALL:
      "studiowebgl_click_bottomnav_expandAll",
    STUDIO_ECA_FACTS_FIELD_SAVE: "studio_eca_facts_field_save",
    STUDIO_ECA_CONDITION_FIELD_SAVE: "studio_eca_conditions_field_save",
    STUDIO_ECA_ADD_ACTION_CLICK: "studio_eca_add_action_click",
    STUDIO_ECA_ADD_CONDITION_CLICK: "studio_eca_add_condition_click",
    STUDIO_ECA_ADD_EVENT_CLICK: "studio_eca_add_event_click",
    STUDIO_ECA_ADD_RULE_CLICK: "studio_eca_add_rule_click",
    STUDIO_ECA_EVENT_RULE_SAVE: "studio_eca_event_rule_save",
    STUDIO_ECA_CONDITION_DELETE: "studio_eca_condition_delete",
    STUDIO_ECA_EVENT_RULE_DELETE: "studio_eca_event_rule_delete",
    STUDIO_ECA_ACTION_DELETE: "studio_eca_action_delete",
    STUDIO_ECA_RULE_DELETE: "studio_eca_rule_delete",
    STUDIO_ECA_INTELLISENSE_SUGGESTION_CLICK:
      "studio_eca_intellisense_suggestion_click"
  },

  studioECADrawerEvents: {
    STUDIO_ECA_DRAWER_ADD_EVENT: "studio_eca_drawer_add_event",
    STUDIO_ECA_DRAWER_DELETE_EVENT: "studio_eca_drawer_delete_event",
    STUDIO_ECA_DRAWER_ADD_RULE: "studio_eca_drawer_add_rule",
    STUDIO_ECA_DRAWER_DELETE_RULE: "studio_eca_drawer_delete_rule",
    STUDIO_ECA_DRAWER_ADD_ACTION: "studio_eca_drawer_add_action",
    STUDIO_ECA_DRAWER_DELETE_ACTION: "studio_eca_drawer_delete_action",
    STUDIO_ECA_DRAWER_REORDER_ACTIONS: "studio_eca_drawer_reorder_actions",
    STUDIO_ECA_DRAWER_EXPAND_COLLAPSE_ACTION:
      "studio_eca_drawer_expand_collapse_action",
    STUDIO_ECA_DRAWER_SELECT_EVENT_TYPE: "studio_eca_drawer_select_event_type",
    STUDIO_ECA_DRAWER_SELECT_FIELD: "studio_eca_drawer_select_field",
    STUDIO_ECA_DRAWER_SELECT_STEP: "studio_eca_drawer_select_step",
    STUDIO_ECA_DRAWER_SELECT_OBJECT: "studio_eca_drawer_select_object",
    STUDIO_ECA_LIST_SELECT_RULE: "studio_eca_list_select_rule",
    STUDIO_ECA_LIST_ADD_RULE: "studio_eca_list_add_rule",
    STUDIO_ECA_LIST_DELETE_RULE: "studio_eca_list_delete_rule",
    STUDIO_ECA_DRAWER_SAVE_RULE: "studio_eca_drawer_save_rule"
  },

  studioAppDetailsEvents: {
    STUDIO_CLICK_DEPLOY_BUTTON_ON_APP_DETAILS:
      "Studio_click_deployButtonOnAppDetails",
    STUDIO_CLICK_DEPLOY_BUTTON_IN_MODAL: "Studio_click_deployButtonInModal",
    STUDIO_CLICK_FORCE_UNLOCK: "Studio_click_forceUnlock",
    STUDIO_CLICK_EDIT_BUTTON: "Studio_click_editButton",
    STUDIO_CLICK_SUBMIT_BUTTON: "Studio_click_submitChangesButton",
    STUDIO_CLICK_CREATE_EDIT_DEPLOY_SAVEPOINT_BTN:
      "Studio_click_createEditDeploySavepointBtn"
  },

  studioAppListEvents: {
    STUDIO_APP_LIST_CREATE_APP_SAVE_CLICK: "studio_click_createAppModal",
    STUDIO_APP_LIST_EDIT_APP_SAVE_CLICK: "studio_click_editApp",
    STUDIO_APP_LIST_CANCEL_CLICK: "studio_click_cancelButton",
    STUDIO_APP_LIST_APP_CLICK: "studio_click_app",
    STUDIO_APP_LIST_CREATE_APP_BUTTON_CLICK: "studio_click_createAppButton",
    STUDIO_APP_LIST_EDIT_APP_BUTTON_CLICK: "studio_click_createAppButton",
    STUDIO_APP_LIST_DROPDOWN_DELETE_APP_CLICK: "studio_click_dropdownDeleteApp",
    STUDIO_APP_LIST_DROPDOWN_EDIT_APP_CLICK: "studio_click_dropdownEditApp"
  },

  studioInstanceSettingsEvents: {
    STUDIO_INSTANCE_SETTINGS_HEADER_USER_PROFILE_CLICK:
      "header_userProfile_click_instanceSettings",
    STUDIO_INSTANCE_SETTINGS_CLICK_BRANDING: "instanceSettings_click_branding",
    STUDIO_INSTANCE_SETTINGS_CLICK_INTEGRATION_CONFIG:
      "instanceSettings_click_integrationConfig",
    STUDIO_INSTANCE_SETTINGS_CLICK_INTEGRATION_TOKENS:
      "instanceSettings_click_integrationTokens",
    STUDIO_INSTANCE_SETTINGS_CLICK_USERS: "instanceSettings_click_users",
    STUDIO_INSTANCE_SETTINGS_CLICK_GLOBAL_SETTINGS:
      "instanceSettings_click_globalSettings",
    STUDIO_INSTANCE_SETTINGS_CLICK_ACCESS: "instanceSettings_click_access",
    STUDIO_INSTANCE_SETTINGS_WF_SHORTCUTS: "instanceSettings_wf_shortcuts",
    STUDIO_INSTANCE_SETTINGS_CLICK_BADGE_DEFINITIONS:
      "instanceSettings_click_badgeDefinitions",
    STUDIO_INSTANCE_SETTINGS_CLICK_SCHEDULER:
      "instanceSettings_click_scheduler",
    STUDIO_INSTANCE_SETTINGS_BRANDING_CLICK_APPLY:
      "instanceSettings_branding_click_apply",
    STUDIO__INSTANCE_SETTINGS_INTEGRATION_CONFIG_CLICK_ADD_CONFIG:
      "instanceSettings_integrationConfig_click_addconfig_add",
    STUDIO_INSTANCE_SETTINGS_INTEGRATION_CONFIG_CLICK_EDIT_ICON:
      "instanceSettingsintegrationConfig_click_editIcon_save",
    STUDIO_INSTANCE_SETTINGS_INTEGRATION_TOKEN_CLICK_ADD_TOKEN:
      "instanceSettings_integrationToken_click_addtoken_add",
    STUDIO_INSTANCE_SETTINGS_INTEGRATION_TOKEN_CLICK_EDIT_ICON:
      "instanceSettingsintegrationToken_click_editIcon_save",
    STUDIO_INSTANCE_SETTINGS_USERS_CLICK_BULK_DOWNLOAD:
      "instanceSettings_users_click_bulkDownload",
    STUDIO_INSTANCE_SETTINGS_USERS_CLICK_ADD_USERS:
      "instanceSettings_users_click_addUsers_add",
    STUDIO_INSTANCE_SETTINGS_USERS_CLICK_EDIT_ICON:
      "instanceSettings_users_click_editIcon_save",
    STUDIO_INSTANCE_SETTINGS_USERS_CLICK_BULK_IMPORT:
      "instanceSettings_users_click_bulkImport",
    STUDIO_INSTANCE_SETTINGS_USERS_BULK_IMPORT_CLICK_IMPORT:
      "instanceSettings_users_bulkImport_click_import",
    STUDIO_INSTANCE_SETTINGS_GLOBAL_SETTINGS_CLICK_SAVE:
      "instanceSettings_globlSettings_click_Save"
  },

  studioSafeguardPromptEvents: {
    STUDIO_SAFEGUARD_PROMPT_CLICK_CONFIRM:
      "studio_safeguardPrompt_click_confirm",
    STUDIO_SAFEGUARD_PROMPT_CLICK_CANCEL: "studio_safeguardPrompt_click_cancel"
  },

  studioPromotionEvents: {
    /**
     * - source_environment: string
     * - target_environment: string
     */
    STUDIO_PROMOTION_MODAL_OPEN: "studio_promotion_modal_open",
    /**
     * - source_environment: string
     * - target_environment: string
     */
    STUDIO_PROMOTION_CLICK_CANCEL: "studio_promotion_click_cancel",
    /**
     * - source_environment: string
     * - target_environment: string
     */
    STUDIO_PROMOTION_CLICK_NEXT_STEP: "studio_promotion_click_nextStep",
    /**
     * - source_environment: string
     * - target_environment: string
     */
    STUDIO_PROMOTION_CLICK_PREVIOUS_STEP: "studio_promotion_click_previousStep",
    /**
     * - source_environment: string
     * - target_environment: string
     * - update_inprogress_workflows: boolean
     */
    STUDIO_PROMOTION_CLICK_PUBLISH: "studio_promotion_click_publish",
    /**
     * - source_environment: string
     * - target_environment: string
     * - deployment_status: string
     * - is_success: boolean
     * - poll_duration_seconds: number
     */
    STUDIO_PROMOTION_DEPLOYMENT_COMPLETE:
      "studio_promotion_deployment_complete",
    /**
     * - integration_name: string
     * - integration_api_type: string
     * - integration_index: number
     * - total_integrations: number
     */
    STUDIO_PROMOTION_INTEGRATION_SELECT: "studio_promotion_integration_select",
    /**
     * - integration_name: string
     * - integration_api_type: string
     * - integration_index: number
     * - total_integrations: number
     */
    STUDIO_PROMOTION_INTEGRATION_REVIEW: "studio_promotion_integration_review",
    /**
     * - environment_name: string
     * - branch_id: number
     */
    STUDIO_PROMOTION_ENV_DROPDOWN_CLICK: "studio_promotion_env_dropdown_click",
    /**
     * - environment_name: string
     * - branch_id: number
     */
    STUDIO_PROMOTION_ENV_CHECKOUT: "studio_promotion_env_checkout",
    /**
     * - environment_name: string
     * - branch_type: "draft" | "hotfix"
     */
    STUDIO_PROMOTION_ENV_CREATE_BRANCH: "studio_promotion_env_createBranch",
    /**
     * - environment_name: string
     * - branch_id: number
     */
    STUDIO_PROMOTION_ENV_VIEW_VERSIONS: "studio_promotion_env_viewVersions"
  },

  searchPageEvents: {
    ADVANCE_SEARCH_TABLE_COLUMN_SELECTOR:
      "advance_search_table_column_selector",
    ADVANCE_SEARCH_KIND_FILTER: "advance_search_kind_filter",
    ADVANCE_SEARCH_CLICK_FILTER: "advanceSearch_click_filter",
    ADVANCE_SEARCH_CLICK_CTA: "advanceSearch_click_cta",
    GLOBAL_SEARCH_CLICK_ADVANCE_SEARCH: "search_click_advanceSearch",
    ADVANCE_SEARCH_SEARCH_BUTTON: "advanceSearch_search"
  },

  recallAIEvents: {
    RECALL_AI_CLICK_FILL_WITH_AI: "recallAI_click_fillWithAI",
    RECALL_AI_CLICK_CLOSE_MODAL: "recallAI_click_closeModal",
    RECALL_AI_CONFIRM: "recallAI_confirm",
    RECALL_AI_CLICK_UNDO: "recallAI_click_undo",
    RECALL_AI_CLICK_UNDO_CONFIRM: "recallAI_click_undo_confirm",
    RECALL_AI_CLICK_CANCEL: "recallAI_click_cancel",
    RECALL_AI_CLICK_CANCEL_CONFIRM: "recallAI_click_cancel_confirm",
    RECALL_AI_CLICK_AGREEMENT_LINK: "recallAI_click_agreementLink",
    RECALL_AI_FIELDS_FILLED: "recallAI_fields_filled",
    RECALL_AI_WELCOME_UPLOAD_MODAL_CLOSE: "recallAI_welcomeUploadModal_close",
    RECALL_AI_WELCOME_UPLOAD_MODAL_FILE_UPLOADED:
      "recallAI_welcomeUploadModal_fileUploaded"
  },

  globalSearchEvents: {
    // For tracking search result clicks
    /**
     * - result_type: "file" | "workflow"
     * - interaction_mode: "mouse" | "keyboard"
     * - result_index: number (1-based)
     */
    GLOBAL_SEARCH_RESULT_CLICK: "globalSearch_result_click",

    // For tracking recent search clicks
    /**
     * - result_type: "file" | "workflow"
     * - interaction_mode: "mouse" | "keyboard"
     * - result_index: number (1-based)
     */
    GLOBAL_SEARCH_RECENT_SEARCH_CLICK: "globalSearch_recentSearch_click",

    // For tracking category selection (comma separated list of categories)
    /**
     * - categories: string (comma separated list of categories) ("file,workflow")
     */
    GLOBAL_SEARCH_CATEGORY_SELECT: "globalSearch_category_select",

    // For tracking keyword searches with debounce
    /**
     * - keyword: string
     * - keyword_count: number
     */
    GLOBAL_SEARCH_KEYWORD_SEARCH: "globalSearch_keyword_search",

    // For tracking filter bar toggle click
    GLOBAL_SEARCH_FILTER_BAR_TOGGLE_CLICK:
      "globalSearch_filterBar_toggle_click",

    // For tracking clicks of reset filter button
    GLOBAL_SEARCH_RESET_FILTER_CLICK: "globalSearch_resetFilter_click",

    // For tracking values user typed in advanced filter
    /**
     * - filter_value: string (comma separated list of values)
     */
    GLOBAL_SEARCH_ADVANCED_FILTER_TYPED: "globalSearch_advancedFilter_typed",

    // For tracking when user clicks a action in preview
    GLOBAL_SEARCH_PREVIEW_ACTION_CLICK:
      "globalSearch_search_preview_action_click"
  },

  workflowPreviewEvents: {
    SELECT_STEP: "workflowPreview_selectStep",
    EXPAND_COLLAPSE_SWIMLANE: "workflowPreview_expandCollapseSwimlane",
    OPEN_FIELD_CONFIG_DRAWER: "workflowPreview_openFieldConfigDrawer",
    MAKE_FIELD_REQUIRED: "workflowPreview_makeFieldRequired",
    MAKE_FIELD_READONLY: "workflowPreview_makeFieldReadonlyOrEditable",
    DELETE_FIELD: "workflowPreview_deleteField",
    DUPLICATE_FIELD: "workflowPreview_duplicateField",
    TOGGLE_FIELD_VISIBILITY: "workflowPreview_toggleFieldVisibility",
    TOGGLE_FIELD_FILTERABLE: "workflowPreview_toggleFieldFilterable",
    TOGGLE_FIELD_ENCRYPTION: "workflowPreview_toggleFieldEncryption",
    OPEN_STEP_CONFIG_DRAWER: "workflowPreview_openStepConfigDrawer",
    DELETE_STEP: "workflowPreview_deleteStep",
    DUPLICATE_STEP: "workflowPreview_duplicateStep",
    OPEN_SWIMLANE_CONFIG_DRAWER: "workflowPreview_openSwimlaneConfigDrawer",
    DELETE_SWIMLANE: "workflowPreview_deleteSwimlane",
    RENAME_FIELD: "workflowPreview_renameField",
    RENAME_STEP: "workflowPreview_renameStep",
    RENAME_SWIMLANE: "workflowPreview_renameSwimlane",
    RESIZE_FIELD: "workflowPreview_resizeField",
    INITIATE_DRAG_FIELD: "workflowPreview_initiateDragField",
    INITIATE_DRAG_STEP: "workflowPreview_initiateDragStep",
    INITIATE_DRAG_SWIMLANE: "workflowPreview_initiateDragSwimlane",
    DROP_FIELD: "workflowPreview_dropField",
    DROP_STEP: "workflowPreview_dropStep",
    DROP_SWIMLANE: "workflowPreview_dropSwimlane",
    OPEN_SWIMLANE_ACCESS: "workflowPreview_openSwimlaneAccessDrawer",
    OPEN_STEP_ACCESS: "workflowPreview_openStepAccessDrawer",
    CHANGE_FIELD_TYPE: "workflowPreview_changeFieldType",
    ADD_FIELD: "workflowPreview_addField",
    SUBMIT_RECORD_BACKED_FIELD_DIALOG:
      "workflowPreview_submitRecordBackedFieldDialog",
    CANCEL_RECORD_BACKED_FIELD_DIALOG:
      "workflowPreview_cancelRecordBackedFieldDialog",
    OPEN_RECORD_BACKED_FIELD_DIALOG:
      "workflowPreview_openRecordBackedFieldDialog",
    UPDATE_FIELD_REGEX: "workflowPreview_updateFieldRegex",
    OPEN_LINK_RECORD_DIALOG: "workflowPreview_openLinkRecordDialog",
    CANCEL_LINK_RECORD_DIALOG: "workflowPreview_cancelLinkRecordDialog",
    SUBMIT_LINK_RECORD_DIALOG: "workflowPreview_submitLinkRecordDialog",

    CONFIG_DRAWER_SAVE: "workflowPreview_configDrawer_save",
    FIELD_CONFIG_POPOVER_SAVE: "workflowPreview_fieldConfigPopover_save"
  },

  hermesEvents: {
    // save flow
    HERMES_SAVE_FLOW_SUCCESS: "hermes_saveFlow_success",
    HERMES_SAVE_FLOW_ERROR: "hermes_saveFlow_error",

    // Flow Management Events
    HERMES_CREATE_FLOW_CLICK: "hermes_createFlow_click",
    HERMES_EDIT_FLOW_CLICK: "hermes_editFlow_click",
    HERMES_DELETE_FLOW_CLICK: "hermes_deleteFlow_click",
    HERMES_EXECUTE_FLOW_CLICK: "hermes_executeFlow_click",
    HERMES_EXPORT_FLOW_CLICK: "hermes_exportFlow_click",
    HERMES_IMPORT_FLOW_CLICK: "hermes_importFlow_click",

    // Node Management Events
    HERMES_ADD_NODE_CLICK: "hermes_addNode_click",
    HERMES_DELETE_NODE_CLICK: "hermes_deleteNode_click",
    HERMES_SELECT_NODE_CLICK: "hermes_selectNode_click",
    HERMES_CONFIGURE_NODE_CLICK: "hermes_configureNode_click",

    // Connection Management Events
    HERMES_CREATE_CONNECTION_CLICK: "hermes_createConnection_click",
    HERMES_EDIT_CONNECTION_CLICK: "hermes_editConnection_click",
    HERMES_DELETE_CONNECTION_CLICK: "hermes_deleteConnection_click",

    // Execution & Monitoring Events
    HERMES_VIEW_EXECUTION_LOGS_CLICK: "hermes_viewExecutionLogs_click",
    HERMES_VIEW_ISSUES_CLICK: "hermes_viewIssues_click",
    HERMES_VIEW_RUNS_CLICK: "hermes_viewRuns_click",

    // Navigation Events
    HERMES_NAVIGATE_TO_FLOWS_CLICK: "hermes_navigateToFlows_click",
    HERMES_NAVIGATE_TO_CONNECTIONS_CLICK: "hermes_navigateToConnections_click",
    HERMES_NAVIGATE_TO_RUNS_CLICK: "hermes_navigateToRuns_click",
    HERMES_NAVIGATE_TO_ISSUES_CLICK: "hermes_navigateToIssues_click"
  },

  batchUpdateEvents: {
    /**
     * Tracks when user opens the batch update modal (shows intent)
     */
    BATCH_UPDATE_PANEL_OPEN: "batchUpdate_panel_open",
    /**
     * Tracks when user clicks submit (frontend validation passed)
     * - workflow_type: string
     * - has_step_tags: boolean
     * - has_resave_fields: boolean
     * - has_clear_fields: boolean
     */
    BATCH_UPDATE_SUBMIT_ATTEMPT: "batchUpdate_submit_attempt",
    BATCH_UPDATE_SUCCESS: "batchUpdate_success",
    BATCH_UPDATE_ERROR: "batchUpdate_error"
  },
  flowViewEvents: {
    FLOW_VIEW_NODE_CLICK: "flowView_node_click",
    FLOW_VIEW_NODE_DOUBLE_CLICK: "flowView_node_doubleclick",
    FLOW_VIEW_EDGE_CLICK: "flowView_edge_click",
    FLOW_VIEW_EDIT_CLICK: "flowView_edit_click",
    FLOW_VIEW_EXPAND_CLICK: "flowView_expand_click",
    FLOW_VIEW_RESETVIEW_CLICK: "flowView_resetview_click",
    FLOW_VIEW_RADIALVIEW_CLICK: "flowView_radialview_click",
    FLOW_VIEW_ON_PANE_CLICK: "flowView_onpane_click",
    FLOW_VIEW_DESIGN_AGENT_CLICK: "flowView_ondesignagent_click",
    FLOW_VIEW_TOP_BANNER_BACK_BUTTON_CLICK: "flowView_topBannerBackButton_click"
  },

  surveyTableFieldEvents: {
    /**
     * Tracks when user clicks the export button
     * - field_id: string
     */
    SURVEY_TABLE_CLICK_EXPORT: "surveyTable_click_export",
    /**
     * Tracks when user changes row selection
     * - field_id: string
     * - selected_items: string[]
     */
    SURVEY_TABLE_SELECTION_CHANGE: "surveyTable_selection_change",
    /**
     * Tracks when user types in search input
     * - field_id: string
     * - search_text: string
     */
    SURVEY_TABLE_SEARCH_TEXT: "surveyTable_search_text",
    /**
     * Tracks when user applies column filters
     * - field_id: string
     * - column_name: string
     * - filter_value: string
     */
    SURVEY_TABLE_COLUMN_FILTER: "surveyTable_column_filter",
    /**
     * Tracks when user applies advanced filters
     * - field_id: string
     * - object_type: string
     * - conditions_count: number
     */
    SURVEY_TABLE_ADVANCED_FILTER_APPLY: "surveyTable_advancedFilter_apply"
  },
  dataObjectEvents: {
    /**
     * Tracks when user searches in data object table
     * - object_type: string
     * - search_term: string
     * - relation_name: string
     */
    DATA_OBJECT_TABLE_SEARCH: "dataObjectTable_search",
    /**
     * Tracks when user applies column filter
     * - object_type: string
     * - column_name: string
     * - relation_name: string
     */
    DATA_OBJECT_TABLE_FILTER: "dataObjectTable_filter",
    /**
     * Tracks when user sorts a column
     * - object_type: string
     * - column_name: string
     * - direction: 'asc' | 'desc'
     * - relation_name: string
     */
    DATA_OBJECT_TABLE_SORT: "dataObjectTable_sort",
    /**
     * Tracks when user changes page
     * - object_type: string
     * - page: number
     * - page_size: number
     * - total_count: number
     * - relation_name: string
     */
    DATA_OBJECT_TABLE_PAGINATION: "dataObjectTable_pagination",
    /**
     * Tracks when data object table loads
     * - object_type: string
     * - relation_name: string
     */
    DATA_OBJECT_TABLE_VIEW: "dataObjectTable_view",
    /**
     * Tracks when user switches tabs in DataObjectOverview
     * - object_type: string
     * - object_id: string
     * - object_tab: string
     */
    DATA_OBJECT_OVERVIEW_TAB_SWITCH: "dataObjectOverview_tab_switch",
    /**
     * Tracks when user clicks activity logs in DataObjectOverview
     * - object_type: string
     * - object_id: string
     */
    DATA_OBJECT_OVERVIEW_ACTIVITY_LOGS_CLICK:
      "dataObjectOverview_activityLogs_click",
    /**
     * Tracks when user switches workflow view/filter in DataObjectWorkflows
     * - kind_tag?: string (null for "All")
     * - view_label?: string
     */
    DATA_OBJECT_WORKFLOWS_VIEW_SWITCH: "dataObjectWorkflows_view_switch",
    /**
     * Tracks when user clicks a workflow row to navigate
     * - workflow_id: number
     * - workflow_name: string
     * - workflow_type: string
     * - current_view?: string
     */
    DATA_OBJECT_WORKFLOWS_ROW_CLICK: "dataObjectWorkflows_row_click",
    /**
     * Tracks when user changes page in workflows table
     * - page: number
     * - page_size: number
     * - total_count: number
     * - current_view?: string
     */
    DATA_OBJECT_WORKFLOWS_PAGINATION: "dataObjectWorkflows_pagination",
    /**
     * Tracks when user clicks to start a new workflow from data object
     * - object_type: string
     * - object_id: string
     * - workflow_kind_tag: string
     * - workflow_kind_name: string
     */
    DATA_OBJECT_ACTIONS_START_WORKFLOW_CLICK:
      "dataObjectActions_startWorkflow_click",
    /**
     * Tracks when workflow creation succeeds from data object
     * - object_type: string
     * - object_id: string
     * - workflow_kind_tag: string
     * - workflow_id: number
     */
    DATA_OBJECT_ACTIONS_START_WORKFLOW_SUCCESS:
      "dataObjectActions_startWorkflow_success",
    /**
     * Tracks when workflow creation fails from data object
     * - object_type: string
     * - workflow_kind_tag: string
     * - error_message?: string
     */
    DATA_OBJECT_ACTIONS_START_WORKFLOW_ERROR:
      "dataObjectActions_startWorkflow_error",
    /**
     * Tracks when user clicks to review existing workflow in modal
     * - object_type: string
     * - existing_workflow_id?: number
     */
    DATA_OBJECT_ACTIONS_REVIEW_EXISTING_CLICK:
      "dataObjectActions_reviewExisting_click",
    /**
     * Tracks when user closes the review warning modal
     * - object_type: string
     */
    DATA_OBJECT_ACTIONS_REVIEW_MODAL_CLOSE:
      "dataObjectActions_reviewModal_close",
    /**
     * Tracks when user clicks review button for monitoring alert
     * - workflow_id?: number
     * - alert_status: "NOT_REVIEWED" | "IN_REVIEW"
     * - added_risks_count: number
     * - removed_risks_count: number
     */
    DATA_OBJECT_MONITORING_REVIEW_CLICK: "dataObjectMonitoring_review_click"
  },
  dataObjectTableFieldEvents: {
    /**
     * Tracks when user filters by status in DataObjectTableField
     * - object_type: string
     * - column_name: string
     */
    DATA_OBJECT_TABLE_FIELD_FILTER: "dataObjectTableField_filter",
    /**
     * Tracks when user selects rows in DataObjectTableField
     * - object_type: string
     * - selected_count: number
     * - is_multi_select: boolean
     * - field_tag: string
     */
    DATA_OBJECT_TABLE_FIELD_ROW_SELECTION: "dataObjectTableField_row_selection",
    /**
     * Tracks when user clears selection in DataObjectTableField
     * - object_type: string
     * - field_tag: string
     */
    DATA_OBJECT_TABLE_FIELD_CLEAR_SELECTION:
      "dataObjectTableField_clear_selection",
    /**
     * Tracks when user navigate to object overview from dataObjectTableField by clicking on name row
     * - object_type: string
     */
    DATA_OBJECT_TABLE_FIELD_NAME_CELL_CLICK:
      "dataObjectTableField_name_cell_click"
  }
} as const;
